import Logo from "./Logo";
import { HOTEL, whatsappUrl } from "../data/site";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Logo />
          <p className="footer-text">
            Simple, comfortable rooms in Hanumangarh, Rajasthan — book directly
            with us on WhatsApp.
          </p>
        </div>
        <div>
          <h2 className="footer-heading">Address</h2>
          <p className="footer-text">
            {HOTEL.addressLine1}
            <br />
            {HOTEL.addressLine2}
          </p>
          <p className="footer-text gap-top-sm">
            <a
              className="footer-link"
              href={HOTEL.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-maps-link"
            >
              Find us on Google Maps
            </a>
          </p>
        </div>
        <div>
          <h2 className="footer-heading">Bookings</h2>
          <p className="footer-text">
            Rooms can be booked directly over WhatsApp.
          </p>
          <p className="footer-text gap-top-sm">
            <a
              className="footer-link"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
            >
              Book on WhatsApp
            </a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          © {new Date().getFullYear()} Hotel Gill Tower, Hanumangarh, Rajasthan
        </div>
      </div>
    </footer>
  );
}
